<template>
  <div class="data-list-container">

    <!-- Prompts -->
    <columns-manager
      :isPromptActive="IsPromptActive.columnsManager"
      :HideableColumns="Columns"
      :isHidden="isHidden"
      @updatePromptColumns="isHidden = $event;"
      @closePromptColumns="IsPromptActive.columnsManager = false;"
      :multipleRows="{ Sales: 'Ventas', Products: 'Productos' }"
    />

    <PromptProductsList
      :isPromptActive="IsPromptActive.productsList"
      :productsList="productsList"
      :SelectedSale="SelectedSale"
      :Columns="Columns.Products"
      :isHidden="isHidden"
      @modifySale="modifySaleDB($event)"
      @closePrompt="IsPromptActive.productsList = false;"
      @openPrompt="IsPromptActive.productsList = true"
      @modifySaleProductDB="modifySaleProductDB($event)"
    />

    <prompt-edit-sale
      :isPromptActive="IsPromptActive.editSale"
      :Sale="saleToEdit"
      @closePrompt="IsPromptActive.editSale = false"
      @modifySale="modifySaleDB($event)"
    />

    <TablePickUpProducts
    :Products="pickUpProducts"
    />

    <tableSales
      :Sales="filteredSales"
      :Columns="Columns.Sales"
      :isHidden="isHidden"
      :EmployeesSales="EmployeesSales"
      :showEmployeesSales="showEmployeesSales"
      @controlStock="loadSaleProducts($event.Sale, controlStock, $event.Params)"
      @modifySaleDB="modifySaleDB($event)"
      @showProducts="showProducts($event)"
      @startEdit="startEdit($event)"
      @copyList="loadSaleProducts($event, copyList, $event);"
      @printList="loadSaleProducts($event, printList, $event)"
      @filterCities="selectedCities = $event"
      @manageColumns="manageColumns()"
      @modifyShowEmployeesSales="changeEmployeesSales($event);"
    />


    <!--IMPRIMIBLE-->
    <form method="post" action="#" id="boletaImprimible" v-if="print">
      <vs-row vs-w="6"> <!-- "vs-w" define el ancho-->
        <vs-col>

          <!-- <img :src="getImg('images/logo/clientHeader.png')" class="py-5 text-center" style="height: 80px"> -->
          <img src="https://rapisuper.lisandrodc.com/images/logo/clientHeader.png" alt="" class="py-5 text-center" style="height: 80px">
          <hr>
          <h3 class="pt-5">Informacion</h3>
          <vs-row>
            <vs-col>
              <vs-row>
                <vs-col>
                  Nombre:
                </vs-col>
                <vs-col>
                  {{SelectedSale.buyerFullName}}
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col>
                  Direccion:
                </vs-col>
                <vs-col>
                  {{getBuyerAddress(SelectedSale)}}
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col>
                  Telefono:
                </vs-col>
                <vs-col>
                  {{SelectedSale.buyerPhone}}
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col>
                  Forma de Pago:
                </vs-col>
                <vs-col>
                  {{SelectedSale.paymentType}}
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col>
                  Hora:
                </vs-col>
                <vs-col>
                  {{getFullReceptionTime(SelectedSale)}}
                </vs-col>
              </vs-row>


            </vs-col>
          </vs-row>

          <hr>
          <h3 class="pt-3">Lista</h3>
          <vs-row>
            <vs-col>
              <ul>
                <li v-for="(prod,index) of productsList" :key="index">
                  {{prod.amount}}u x {{prod.fullName}} = ${{prod.amount*prod.price}}
                </li>
                <hr>

                <p>Total: <b>${{showPrice(SelectedSale.totalTotal2)}}</b> </p>
                <p v-if="SelectedSale.paymentTypeID == 1 && SelectedSale.paymentPrediction">{{showPaymentPrediction(SelectedSale.paymentPrediction)}}</p>

              </ul>
            </vs-col>
          </vs-row>

        </vs-col>
      </vs-row>

    </form>

  </div>


</template>











<script>
// mixins
import { vsTableConfig } from '@/mixins/vsTableConfig.js';
import printJS from 'print-js'

export default {
  mixins: [
    vsTableConfig,
  ],
  components: {
    PromptProductsList: () => import('./components/sales/PromptProductsList.vue'),
    PromptEditSale: () => import('./components/sales/PromptEditSale.vue'),
    TableSales: () => import('./components/sales/TableSales.vue'),
    TablePickUpProducts: () => import('./components/sales/TablePickUpProducts.vue'),
  },
  data: ()=>({
    print: false,
    active: true,
    // Promts
    EmployeesSales: [],
    showEmployeesSales: false,
    IsPromptActive: { productsList: false, editSale: false, },
    saleToEdit: {},
    productsList: [],
    SelectedSale: {},
    selectedCities: [],
    Sales: [],
    pickUpProducts: [],

    isHidden: { Sales: [ 'showProducts' ], Products: [], },
    // static
    Columns: {
      Sales: [
        { name: 'id'              , title: 'ID', },
        { name: 'date'            , title: 'Fecha de compra', nowrap: false, },
        { name: 'isPrinted'       , title: 'Imp.', },
        { name: 'productsAmount'  , title: 'Cant.', },
        { name: 'isStockControled', title: 'Stock controlado', nowrap: false, },
        { name: 'controlStock'    , title: 'Controlar stock', nowrap: false, },
        { name: 'states'          , title: 'Estado', },
        { name: 'functions'       , title: 'Funciones', },
        { name: 'buyerID'         , title: 'ID Comprador' },
        { name: 'buyerEmployee'   , title: 'Empleado' },
        { name: 'buyer'           , title: 'Comprador', },
        { name: 'isPayed'         , title: 'Pagado', },
        { name: 'paymentType'     , title: 'Pago', },
        { name: 'paymentDatetime' , title: 'Fecha de pago', nowrap: false, },
        { name: 'shippingNeeded'  , title: 'Envío', },
        { name: 'reception'       , title: 'Horario de entrega', },
        { name: 'total'           , title: 'Total', },
        { name: 'address'         , title: 'Dirección', },
        { name: 'phone'           , title: 'Teléfono', },
        { name: 'notes'           , title: 'Notas', },
        { name: 'reportIssue'     , title: 'Cancelar', },
      ],
      Products: [
        { name: 'id'              , title: 'ID' },
        { name: 'state'           , title: 'Estado' },
        { name: 'img'             , title: 'Img' },
        { name: 'amountAndName'   , title: 'Cantidad y nombre' },
        { name: 'totalPrice'      , title: 'Total' },
        // { name: 'change'          , title: 'Cambiar' },
        { name: 'modify'          , title: 'Modificar' },
        { name: 'modify'          , title: 'Eliminar' },
      ],
    },
    // selectedProfile: 0, // Lisandro
    selectedProfile: 1, // Lautaro
    Profiles: [
      /* 00 - Lisandro */ { Sales: [], Products: [] },
      /* 01 - Lautaro */  { Sales: [ 'id', 'buyerID', 'buyerEmployee', 'date', 'isStockControled', 'controlStock', 'state', 'paymentDatetime', 'notes', ], Products: [ 'id', ], },
      /* 02 - Aldana   */ { Sales: [ 'id', 'total', 'functions', 'address', 'paymentType', ], Products: [ 'id', ], },
      /* 03 - Rider   */  { Sales: [ 'id', 'total', 'functions', ], Products: [ 'id', ], },
    ],
  }), // DATA
  computed: {
    filteredSales: function() {
      if (!this.selectedCities.length) return this.Sales;
      // this.$vs.loading({
      //   container: `#filterCities`,
      //   scale: 0.6
      // });
      let filtered = this.Sales.filter( Sale => {
        for (let City of this.selectedCities) {
          if (Sale.buyerCityID == City.id) return true;
        }
      });
      // this.$vs.loading.close(`#filterCities`);
      return filtered;
    }
  }, // COMPUTED
  created() {
    this.loadSales();
  },
  watch: {
    selectedProfile: function() {
      this.loadProfile();
    },
  }, // WATCH
  methods: {
    // controlStock
    // checkPickUpProductsForToday
    // checkSaleIsFinished
    // copyList
    // modifySaleDB
    // loadSaleProducts
    // loadSales
    // loadProfile
    // reportIssueProduct
    // startEdit
    changeEmployeesSales(val) {
      this.showEmployeesSales = val;
      this.loadSales();
      this.isHidden.Sales.buyerEmployee = !val;
      this.isHidden.Sales.buyer = val;
    },
    controlStock(Params) {
      Params.addStock = Params.addStock ? Params.addStock : false;
      for (let Prod of this.productsList) {
        let ParamsToDB = {
          productID: Prod.productID,
          amount:    Prod.amount*(Params.addStock ? +1 : -1),
          websiteZoneID: Params.websiteZoneID,
        }
        this.updateProductStock(ParamsToDB);
      }
    },
    checkPickUpProductsForToday(OriginalSale) {
      let Sale = this.copyObj(OriginalSale);
      const vm = this;
      this.conectToDB({
        file: 'Sales', action: 'getSaleProducts', params: { saleID: Sale.id, isActive: 1, },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let SaleProducts = res.data.data;
          for (let SaleProd of SaleProducts) {
            if (!SaleProd.pickUpPlaceID) continue;
            if (SaleProd.pickUpPlaceStateID == vm.dataDB.ProductPickUpStateIDs.Recibido) continue;
            let newSaleProd = vm.copyObj(SaleProd);
            newSaleProd.buyerFullName = Sale.buyerFullName;
            newSaleProd.receptionTimeFull = vm.getFullReceptionTime(Sale);
            newSaleProd.receptionTime = Sale.receptionTime;
            for (var i = 0; i < vm.pickUpProducts.length; i++) {
              let Prod = vm.pickUpProducts[i];
              if (Prod.receptionTime <= newSaleProd.receptionTime) {
                vm.pickUpProducts.splice(i, 0, newSaleProd);
                return;
              }
            }
            vm.pickUpProducts.push(newSaleProd);
            return;
          }
        },
      });
    },
    checkSaleIsFinished(stateID) {
      if (stateID == this.dataDB.SaleStateIDs.Desconocido)  return true;
      if (stateID == this.dataDB.SaleStateIDs.Cancelado)  return true;
      return false;
    },
    copyList(Sale) {
      let msg = `Lista copiada para la compra de <b>${Sale.buyerFullName}</b>`;
      // Get text
      let details = '';
      let totalTotal = 0;
      let changesDetails = '';
      let missingProductsDetails = '';
      for (let Prod of this.productsList) {
        let totalProduct = this.showPrice(Prod.amount * Prod.price);
        if (Prod.noStock || Prod.isAdded) {
          if (Prod.noStock) {
            missingProductsDetails += `${Prod.amount}u x ${Prod.fullName} = $0 (Descontado por falta de stock)\r\n`;
          } else if (Prod.isAdded) {
            if (Prod.isAddedByProductID == 0) {
              changesDetails += `${Prod.amount}u x ${Prod.fullName} = $${totalProduct} (Agregado)\r\n`;
            } else {
              changesDetails += `${Prod.amount}u x ${Prod.fullName} = $${totalProduct} (Agregado en reemplazo de ${Prod.isAddedByProductName})\r\n`;
            }
            totalTotal += +totalProduct;
          }
        } else {
          details += `${Prod.amount}u x ${Prod.fullName} = $${totalProduct}\r\n`;
          totalTotal += +totalProduct;
        }
      }
      let text = '';
      text += Sale.buyerFullName == '' ? '' : `NOMBRE: ${Sale.buyerFullName}\r\n`
      text += Sale.buyerCityID == 0 ? '' : `DIRECCIÓN: ${this.getBuyerAddress(Sale)}\r\n`
      text += !Sale.buyerPhone ? '' : `TELÉFONO: ${Sale.buyerPhone}\r\n`
      text += `FORMA DE PAGO: ${Sale.paymentType}\r\n`
      if (Sale.shippingNeeded) {
        text += Sale.receptionTime == this.emptyDate ? '' : `HORA: ${this.getFullReceptionTime(Sale)} - ${this.getDateOfDB(Sale.receptionDate, true)}\r\n`
      } else {
        text += 'RETIRO EN LOCAL'
      }
      text += this.getControlDetailsOfSale(Sale)+'\r\n';
      if (details != '') {
        text += '\r\nPEDIDO\r\n';
        text += `${details}`;
      }
      if (missingProductsDetails) {
        text += '\r\nFALTANTES\r\n';
        text += `${missingProductsDetails}`;
      }
      if (changesDetails != '') {
        text += '\r\nCAMBIOS\r\n';
        text += `${changesDetails}`;
      }
      text += `\r\nTOTAL: $${this.showPrice(totalTotal)}\r\n`;
      if (Sale.paymentTypeID == 1 && Sale.paymentPrediction) {
        text += `${this.showPaymentPrediction(Sale.paymentPrediction)}\r\n`;
      }
      this.copyToClipboard(text, msg);
    },

    printList() {
      console.log("Printing")
      var totalTotal = 0
      for (let Prod of this.productsList) {
        let totalProduct = Prod.amount * Prod.price;
        totalTotal = totalTotal + totalProduct;
      }

      this.SelectedSale.totalTotal2 = totalTotal

      let vm = this
      this.print = true
      setTimeout( //Atado con alambre
        ()=> {
          printJS({
                  printable: 'boletaImprimible',
                  type: 'html',
                  targetStyles: ['*'],
                  //style: "#boletaImprimible {visibility: visible; height: auto; width: auto;}",
                  documentTitle: "RapiSuper",
                  onLoadingStart: function () {
                  },
                  onLoadingEnd: function () {
                    vm.print = false
                  }
                });

        }, 50
      )

    },

    modifySaleProductDB(Params) {
      this.conectToDB({
        file: 'Sales', action: 'modifySaleUProduct', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        //   let msg = `${!SaleProd.isReady ? '' : 'ya no ' }está listo`
        //   // vm.myNotify('success', 'Éxito', `<b>${SaleProd.fullName}</b> ${msg}`);
        //   console.log(`"${SaleProd.fullName}" ${msg} - (ID: ${SaleProd.id})`);
        },
      });
    },
    modifySaleDB(Params) {
      const vm = this;
      this.conectToDB({
        file: 'Sales', action: 'modifySale', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        },
      });
    },
    loadSaleProducts(Sale, callback = '', Params = {}) {
      this.SelectedSale = Sale;
      const vm = this;
      this.conectToDB({
        file: 'Sales', action: 'getSaleProducts', params: { saleID: Sale.id, isActive: 1, },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.productsList = res.data.data;
          console.log(res.data.data);
          if (callback != '') {
            callback(Params);
          }
        },
      });
    },
    loadSales() {
      let SaleStateIDs = this.dataDB.SaleStateIDs;
      let Params = {
        hasBuyerEmployeeID: this.showEmployeesSales,
      };
      if (this.isOnlySales) {
        Params.stateIDminor = SaleStateIDs.Entregado;
      }
      const vm = this;
      this.conectToDB({
        file: 'Sales', action: 'getSale', params: Params,
        success: function(res){
          if (!vm.checkDBResponse(res)) return;
          let Sales = res.data.data;
          console.log(Sales);
          vm.pickUpProducts = [];
          for (let Sale of Sales) {
            Sale.Cancelado = !!Sale.stateID == SaleStateIDs.Cancelado;
            Sale.isPayed = Sale.paymentDatetime != vm.emptyDate;
            if (Sale.receptionDate != vm.getActualDateToDB()) continue;
            if (Sale.stateID == SaleStateIDs.Cancelado) continue;
            vm.checkPickUpProductsForToday(Sale);
          }
          if (vm.showEmployeesSales) {
            vm.EmployeesSales = Sales;
          } else {
            vm.Sales = Sales;
          }
          // // Order by sales state
          // vm.Sales = [];
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Pedido) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.EnArmado) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Armado) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.EnControl) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Controlado) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.EnCamino) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Entregado) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Desconocido) vm.Sales.push(Sale);
          // }
          // for (let Sale of Sales) {
          //   if (Sale.stateID == SaleStateIDs.Cancelado) vm.Sales.push(Sale);
          // }
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    showProducts(Sale) {
      this.loadSaleProducts(Sale);
      this.IsPromptActive.productsList = true;
    },
    startEdit(Sale) {
      this.saleToEdit = Sale;
      this.IsPromptActive.editSale = true;
    },

  }, // METHODS
}
</script>















<style lang="scss">
  .notOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .payment0{ color:rgb(255, 159, 67); } // Error
  .payment1 { color: #209353 } // Efectivo
  .payment2 { color: #1F1590 } // Argentino / Central
  .payment3 { color: #FF4136 } // Otras tarjetas

  .productAmount {
    font-weight: bold;
  }

  #boletaImprimible {
    //visibility: hidden;
    // height: 0;
    .vs-row {
      flex-flow: unset;
    }
  }

</style>




<!-- vm.$set(vm.Sales[position], 'Products', res.data.data)


for (let i in vm.Sales) {
  vm.loadSaleProducts(vm.Sales[i].id, i);
} -->
